import {
  Body,
  Box,
  Container,
  Heading,
  Icon,
  SimpleGrid,
  VStack,
} from '@hover/blueprint';
import { iCloudRain, iMonitor, iSun } from '@hover/icons';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

const SlideDesktop: React.FC = () => (
  <SimpleGrid
    d={{ base: 'none', desktop: 'grid' }}
    columns={2}
    spacing="60px"
    alignItems="center"
    w="100%"
  >
    <VStack spacing="54px" alignItems="flex-start" alignSelf="flex-start">
      <Box flexDir="column" maxW="560px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon
            size="default"
            mr={400}
            icon={iCloudRain}
            color="brandNavy.500"
          />
          <Body size={200} isBold color="brandNavy.500" as="h4">
            PROBLEM
          </Body>
        </Box>
        <Heading size={500} isDisplay marginBottom={0} as="p">
          Rapid Roofing wanted to distinguish themselves from the high-pressure,
          murky sales approach employed by their competition.
        </Heading>
      </Box>
      <Box flexDir="column" maxW="584px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon size="default" mr={400} icon={iSun} color="brandNavy.500" />
          <Body size={200} isBold color="brandNavy.500" as="h4">
            SOLUTION
          </Body>
        </Box>
        <Heading size={500} isDisplay marginBottom={0} as="p">
          Customers feel confident knowing that there’s nothing being hidden.
          After adopting HOVER, close rates on siding jobs increased from 30% to
          75%.
        </Heading>
      </Box>
      <Box flexDir="column" maxW="584px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon size="default" mr={400} icon={iMonitor} color="brandNavy.500" />
          <Body size={200} isBold color="brandNavy.500" as="h4">
            PRODUCT USED
          </Body>
        </Box>
        <Box flexDir="column">
          <Heading size={500} isDisplay marginBottom={100} as="p">
            Measurements PDF
          </Heading>
          <Heading size={500} isDisplay marginBottom={0} as="p">
            Design in 3D
          </Heading>
        </Box>
      </Box>
    </VStack>
    <Container flexDir="column" maxW="556px" px={0}>
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="real time 3d"
        objectFit="contain"
        src="../../../assets/images/exterior_contractor_case_study_1.png"
      />
      <Box
        p={400}
        w="100%"
        bg="brandNavy.500"
        mt={200}
        borderRadius="0 0 8px 8px"
        dropShadow="medium"
      >
        <Body size={300} color="neutral.0" isSemiBold>
          Rapid Roofing is a residential and commercial exterior contractor in
          Southeast Michigan. The company was founded by brothers Bill and Mike
          Beaty, who grew up working in the roofing industry alongside their
          father.
        </Body>
      </Box>
    </Container>
  </SimpleGrid>
);

export default SlideDesktop;
